import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrendingCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTrendingCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 11.5607V14H17V9H12V10.5H14.4393L12 12.9393L10 10.9393L6.43934 14.5L7.5 15.5607L10 13.0607L12 15.0607L15.5 11.5607Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrendingCircle;
